import { Flex } from '@mantine/core';

import { translate } from '@/shared/i18n/translate';
import { LBButton } from '@/shared/ui-kit/components';

export const ManageWorkInviteView = ({
  rejectInvite,
  acceptInvite
}: {
  rejectInvite: () => void;
  acceptInvite: () => void;
}) => (
  <Flex gap={8}>
    <LBButton fullWidth onClick={rejectInvite}>
      {translate('commons.reject')}
    </LBButton>
    <LBButton fullWidth onClick={acceptInvite}>
      {translate('commons.accept')}
    </LBButton>
  </Flex>
);
